import {createApp} from 'vue'
import App from './App.vue'
import Store from './Services/Store.js';
import Helpers from "@/mixins/Helpers";

import './assets/style.scss'

createApp(App)
  .mixin(Helpers)
  .use(Store)
  .mount('#shop-order-form');
